var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2062_12760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.169 14.5643C30.169 6.52067 23.4154 0 15.0845 0C6.75355 0 0 6.52067 0 14.5643C0 21.8337 5.51615 27.8591 12.7275 28.9517V18.7743H8.89749V14.5643H12.7275V11.3556C12.7275 7.70544 14.9796 5.68919 18.4252 5.68919C20.075 5.68919 21.8018 5.97365 21.8018 5.97365V9.55784H19.8997C18.026 9.55784 17.4414 10.6806 17.4414 11.8335V14.5643H21.625L20.9562 18.7743H17.4414V28.9517C24.6528 27.8591 30.169 21.8337 30.169 14.5643Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2062_12760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.169,
    height: 29.1287,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.6134b738acdf317398477385625ae190.svg";
export { ForwardRef as ReactComponent };